module.exports = __webpack_public_path__ + "fonts/fa-light-300.edf31742.woff2";